// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1DatabaseType = {
  StandardDatabaseType: 'standard',
  SpdDatabaseType: 'sharded',
} as const;
export type V1DatabaseType =
  (typeof V1DatabaseType)[keyof typeof V1DatabaseType];

export function instanceOfV1DatabaseType(value: any): boolean {
  for (const key in V1DatabaseType) {
    if (Object.prototype.hasOwnProperty.call(V1DatabaseType, key)) {
      if (V1DatabaseType[key as keyof typeof V1DatabaseType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function V1DatabaseTypeFromJSON(json: any): V1DatabaseType {
  return V1DatabaseTypeFromJSONTyped(json, false);
}

export function V1DatabaseTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1DatabaseType {
  return json as V1DatabaseType;
}

export function V1DatabaseTypeToJSON(value?: V1DatabaseType | null): any {
  return value as any;
}

export function V1DatabaseTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1DatabaseType {
  return value as V1DatabaseType;
}
